import { POST_ACTIVITY } from 'botframework-webchat-core/lib/actions/postActivity';
import { SET_SEND_BOX } from 'botframework-webchat-core/lib/actions/setSendBox';
import { START_DICTATE } from 'botframework-webchat-core/lib/actions/startDictate';
import { START_SPEAKING_ACTIVITY } from 'botframework-webchat-core/lib/actions/startSpeakingActivity';
import { isPreventAcknowledgementAction } from './preventAcknowledgementOfInitialActivitiesMiddleware';
const userInitiatedActions = {
    [POST_ACTIVITY]: true,
    [SET_SEND_BOX]: true,
    [START_DICTATE]: true,
    [START_SPEAKING_ACTIVITY]: true
};
export const isUserInitiatedAction = (action) => {
    return userInitiatedActions[action.type] && !isPreventAcknowledgementAction(action);
};
export function onUserActionMiddleware(callback) {
    return () => (next) => (action) => {
        if (isUserInitiatedAction(action)) {
            callback(action);
        }
        return next(action);
    };
}
//# sourceMappingURL=onUserActionMiddleware.js.map